module.exports = __webpack_public_path__ + "static/media/icon-chat.407f1506.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/icon-chat.svg
// module id = 1864
// module chunks = 0